import React, { useState } from "react";
import CategoryListComponent from "./categoryList.component";
import {AccessRights} from "lib/constants/accessRights";
import { useSelector } from "react-redux";
import {canAccess} from "../../../profile/redux/selector/profile.selector";

function CategoryListContainer() {
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const isCategoryEdit = useSelector(
    (state) => state.products.categoryList.isEdit
  );
  const lang = useSelector((state) => state.constant.languages);
  const hasProductCategoryAddAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Product.CATEGORY_CREATE)
  );

  const handleCreateCategory = (value) => {
    setIsCreateDialogOpen(value);
  };

  return (
    <>
      <CategoryListComponent
        hasProductCategoryAddAccessRight={hasProductCategoryAddAccessRight}
        handleCreateCategory={handleCreateCategory}
        isCreateDialogOpen={isCreateDialogOpen}
        isCategoryEdit={isCategoryEdit}
        lang={lang}
      />
    </>
  );
}

export default CategoryListContainer;
